import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./ClinicGames.scss";
import filter from "lodash/filter";
import includes from "lodash/includes";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import * as ClinicActions from "actions/ClinicActions";
import AccessDenied from "components/common/AccessDenied";
import BasicGridTiles from "components/common/BasicGridTiles";
import BiProductDisclosures from "components/common/BiProductDisclosures";
import Button from "components/common/Button";
import ClinicBase from "components/layout/ClinicBase";
import GreenlineGameCard from "components/games/elements/GreenlineGameCard";
import JoyRide from "components/tour/widgets/JoyRide";
import { TOUR_GAMES_PART_3 } from "utils/demoTourHelpers";
import { getNodeId } from "utils/AdminData";
import * as ClinicAdminLinks from "utils/ClinicAdminLinks";
import * as ClinicLinks from "utils/ClinicLinks";
import { getClinicGames, getClinicInfo } from "utils/ClinicData";
import getPrimaryClinicIdForUser from "utils/getPrimaryClinicIdForUser";
import { PermissionTypes, userHasPermission } from "utils/permissions/rolesPermissions";
import { CLINIC_TAGS } from "constants/AdminControls";
import * as DemoTourStates from "constants/DemoTourStates";
import * as UserPermissions from "constants/UserPermissions";

function ClinicGames(props) {
    const history = useHistory();
    const { pathname } = useLocation();
    const isAdmin = !!includes(pathname, "/admin");
    const [gamesList, setGamesList] = useState([]);
    const [tourSection, setTourSection] = useState(null);

    useEffect(() => {
        if(props.canViewClinicBIGamesDashboard) {
            props.getClinicGreenlineGames(props.clinicId);
        }
    }, [props.clinicId]);

    const getTourSection = () => {
        if (!includes(props.completedTourSections, TOUR_GAMES_PART_3)){
            setTourSection(TOUR_GAMES_PART_3);
        }
    }

    useEffect(() => {
        getTourSection();
    }, [props.completedTourSections]);

    useEffect(() => {
        setGamesList(orderBy(filter(props.games, game => game.isCurrent === true), ["startDate"], ["desc"]));
    }, [props.games])

    const goToHistoric = () => {
        if (isAdmin) {
            history.push(ClinicAdminLinks.getLinkLocation("historic-games", props.clinicId));
        } else {
            history.push(ClinicLinks.getLinkLocation("historic-games"));
        }
    };

    const getAllCards = () => {
        return map(gamesList, game => (
            <GreenlineGameCard
                game={game}
                key={`game_${game.greenlineGameId}`}
                clinicId={props.gameClinicId}
                nodeId={props.nodeId}
            />
        ));
    }

    return (
        <ClinicBase
            pageTitle="Greenline Games™"
            clinicId={props.clinicId}
            adminControls={CLINIC_TAGS}
            overflowHidden
        >
            <div className={styles.root}>
                {props.canViewClinicBIGamesDashboard ? (
                    <>
                        <section className={styles.gamesContainer}>
                            <div className={"flex border-bottom"}>
                                <Button onClick={() => {}}>
                                    Current Games
                                </Button>
                                <div id="tour_historic_games_btn">
                                    <Button onClick={goToHistoric}>
                                        Historic Games
                                    </Button>
                                </div>
                            </div>
                            <h3>Current Games</h3>
                            {!!gamesList.length ? (
                                <BasicGridTiles tiles={getAllCards()} large />
                            ):(
                                <div>No Current Games Available</div>
                            )}
                        </section>
                        <div className="text-x-sm border-top margin-bottom-sm padding-md">
                            <BiProductDisclosures/>
                        </div>
                        <JoyRide
                            key={tourSection}
                            tourSection={tourSection}
                        />
                    </>
                ) : (
                    <AccessDenied/>
                )}
            </div>
        </ClinicBase>
    );
}

export default connect(
    (state, ownProps) => {
        const adminClinicId = Number(ownProps.match.params.clinicId);
        const nodeId = getNodeId(state, ownProps);
        const clinicInfo = getClinicInfo(state, adminClinicId);
        const clinicId = clinicInfo ? clinicInfo.clinicId : undefined;
        const userProfile = state.user.userProfile;
        const canViewClinicBIGamesDashboard = userHasPermission(PermissionTypes.VIEW, UserPermissions.CLINIC_BI_GAMES_DASHBOARD, userProfile);

        return {
            clinicId,
            canViewClinicBIGamesDashboard,
            gameClinicId: Number(clinicId || getPrimaryClinicIdForUser(state.user.userProfile)),
            games: getClinicGames(state),
            completedTourSections: state.demo.completedTourSections,
            tourStarted: (state.demo.demoTourState === DemoTourStates.STARTED),
            nodeId,
            clinicInfo,
        }
    },
    (dispatch) => ({
        getClinicGreenlineGames: (clinicId) => dispatch(ClinicActions.getGreenlineGames(clinicId)),
    }),
)(ClinicGames);
